import OKeyboardStandard from './o-keyboard-standard';

export default OKeyboardStandard;